import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';
import { useTranslation } from 'react-i18next';
import { RoundedPaper } from '../../lib/components';
import { InfoIcon } from '../../lib/icons';
import Util from '../../misc/util';
import { TooltipComponent } from '../../lib/components/atomic/feedback';

interface SalaryCardProps {
  salary?: number;
  reference?: number;
  sx?: SxProps<Theme>;
}

export const SalaryCard: FC<SalaryCardProps> = ({ salary = 0, reference = 0, sx }) => {
  const { t } = useTranslation('calculator');

  const [oldSalary, setOldSalary] = useState(0);
  const counter = useCountUp({
    ref: 'salary',
    start: oldSalary,
    end: salary,
    formattingFn: (salary) => Util.formatCurrency(salary, false),
    duration: 1,
    startOnMount: false
  });

  useEffect(() => {
    counter.getCountUp().startVal = oldSalary;
    counter.update(salary);
    setOldSalary(salary);
    counter.start();
  }, [salary]);

  return (
    <RoundedPaper sx={{ padding: '1.25rem', ...sx }}>
      <Box display="flex">
        <Typography variant="h3">{t('SALARY_CARD_TITLE')}</Typography>
        <TooltipComponent title={t('MONTHLY')} placement="right" arrow>
          <Box paddingLeft="8px" maxWidth="fit-content">
            <InfoIcon height={28} width={18} color="grey.500" />
          </Box>
        </TooltipComponent>
      </Box>
      <Typography variant="h1" id="salary" fontWeight="bold" color="heaven.main" />
      <Typography variant="body2" color="grey.500">
        {t('SALARY_CARD_REFERENCE', { salary: Util.formatCurrency(reference) })}
      </Typography>
    </RoundedPaper>
  );
};
